import SynappTour from './SynappTour'

export default SynappTour
